module.exports = __webpack_public_path__ + "media/images/landing_page/2023/webpage/majaslapa-programma-a95d3a0520f4fe578db17b011b76e9a1.webp";